import styled, { css } from 'styled-components';

export const AboutPage = styled.section`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
  width: 100%;
  will-change: contents;
  z-index: 1;
  transform-style: preserve-3d;
  animation: fadeIn 1s forwards;
  animation-delay: 2.5s;
  opacity: 0;
  padding: 8rem 4rem;

  @media (max-width: 788px) {
    flex-direction: column;
    grid-gap: 5rem;
  }
  @media (max-width: 588px) {
    padding: 0rem 2rem;
    padding-bottom: 5rem;
  }
  @media (max-width: 330px) {
    padding: 5rem 1.3rem;
  }

  h1 {
    color: #3bcfe3;
    font-weight: 400;
    font-family: 'Lato', sans-serif;
    margin-top: 0;
    position: relative;
    margin-bottom: 40px;
    left: -10px;
    @media (max-width: 695px) {
      margin-bottom: 20px;
    }

    &:before {
      content: '<h1>';
      opacity: 0.3;
      color: #3bcfe3;
      font-size: 18px;
      font-family: 'La Belle Aurore', cursive;
      position: absolute;
      margin-top: -10px;
      left: -10px;
      line-height: 18px;
    }

    &:after {
      content: '<h1/>';
      color: #3bcfe3;
      opacity: 0.3;
      font-size: 18px;
      font-family: 'La Belle Aurore', cursive;
      line-height: 18px;
      position: absolute;
      left: -30px;
      bottom: -20px;
      margin-left: 20px;
    }
  }

  p {
    font-size: clamp(0.85rem, 3vw, 0.95rem);
    line-height: 26px;
    letter-spacing: 0.05rem;
    word-spacing: 0.15rem;
    color: #D6D6D6;
    font-size: clamp(1rem, 2.5vw, 1.2rem); 
    font-family: sans-serif;
    max-width: fit-content;
    animation: pulse;
    animation-duration: 0.45s;
    animation-fill-mode: both;
    animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);

    &:nth-of-type(1) {
      animation-delay: 1.1s;
    }
    &:nth-of-type(2) {
      animation-delay: 1.2s;
    }
    &:nth-of-type(3) {
      animation-delay: 1.3s;
    }
  }

  .text-zone {
    max-width: 35rem;
    width: 100%;
    vertical-align: middle;
    display: table-cell;
    max-height: 90%;
    transform: translate(30%, 30%);
    opacity: 0;
    -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);

    @media (max-width: 1200px) {
      max-width: 28rem;
      width: 100%;
    }
    @media (max-width: 1045px) {
      max-width: 22rem;
      width: 100%;
    }
    @media (max-width: 788px) {
      max-width: 42rem;
      width: 100%;
    }
    ${({ isVisible }) =>
      isVisible &&
      css`
        -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transform: translate(0%, 0%);
        opacity: 1;
      `}
  }
  .profile-img {
    width: 40%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 22rem;
    margin-top: -6rem;
    margin-left: 4rem;
    transform: translate(-30%, 30%);
    opacity: 0;
    -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
    transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);

    @media (max-width: 1280px) {
      margin-left: 0rem;
    }
    @media (max-width: 699px) {
      margin: unset;
      grid-gap: 2rem;
      gap: 2rem;
      width: 95%;
    }
    @media (max-width: 599px) {
      grid-gap: 0rem;
      gap: 0rem;
      margin-left: 4rem;
    }

    .profile-element {
      max-width: 22rem;
      width: 100%;
      img {
        border-radius: 20%;
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    ${({ isInView }) =>
      isInView &&
      css`
        -webkit-transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transition: all 1.6s cubic-bezier(0.39, 0.575, 0.565, 1);
        transform: translate(0%, 0%);
        opacity: 1;
      `}
  }
`;
